/**
 * Description to write when a link is selected, or null to leave the field alone
 * (MPN-1959). The text is the link's name, as the picker labels it. The field is
 * ours to fill while it is blank or still holds, unedited, what the previous link
 * prefilled; once the writer has changed it, it is theirs.
 */
export function nextLinkDescription(
    current: string,
    lastPrefilled: string,
    linkName: string,
): string | null {
    const untouched = current.trim() === '' || (lastPrefilled !== '' && current === lastPrefilled);
    if (!untouched) return null;
    return linkName.trim() ? linkName : '';
}
